import { useContext } from 'react';
import PauseMonitoringContext from './PauseMonitoringContext';

const usePauseMonitoringContext = () => useContext(PauseMonitoringContext);

export default usePauseMonitoringContext;
